import * as React from 'react';
import Media from 'react-media';

import { breakPoint } from '@coursera/coursera-ui';

export const withIsMobile = (Component: $TSFixMe) => (props: $TSFixMe) =>
  <Media query={{ minWidth: breakPoint.lg }}>{(matches) => <Component {...props} isMobile={!matches} />}</Media>;
